/*jshint esversion: 11 */

import Panzoom from '@panzoom/panzoom';

// No bundle (e não <script> inline no Blade): estes modais entram na página por AJAX do
// Livewire 3, que insere o HTML via template.innerHTML e nunca executa <script> -- as
// funções globais definidas inline ficavam indefinidas e o x-data quebrava.
// Os dados do servidor (@entangle, @js) chegam como argumentos do x-data.

function attachPanzoom(getElem, {fit = false, minScale = 1, excludeClass = 'seat selectionable-sector', delay = 200} = {}) {
    // Espera o modal terminar de abrir para medir a altura do mapa.
    setTimeout(() => {
        const elem = getElem();
        if (!elem || !elem.parentElement) return;

        const parent = elem.parentElement;
        let startScale = 1;
        let startY = 0;

        if (fit && elem.offsetHeight > parent.offsetHeight) {
            startScale = parent.offsetHeight / elem.offsetHeight;
            startY = 0 - ((elem.offsetHeight - parent.offsetHeight) / 2);
        }

        const panzoom = Panzoom(elem, {
            maxScale: 5,
            minScale: fit ? startScale : minScale,
            startScale,
            startY,
            animate: true,
            excludeClass,
        });

        parent.addEventListener('wheel', panzoom.zoomWithWheel);
    }, delay);
}

// Base dos seletores de assento do painel (cortesia e venda de ingresso bloqueado).
const seatPickerBase = (selectedSeats, {clickSelector, fit, minScale}) => ({
    selectedSeats,
    tempSelectedSeats: [],
    inited: false,

    init() {
        if (this.inited) return;
        this.tempSelectedSeats = [...this.selectedSeats];

        this.$watch('tempSelectedSeats', Alpine.debounce(() => {
            this.selectedSeats = this.tempSelectedSeats;
        }, 300));

        this.$refs.mapbgzoom.addEventListener('click', (e) => {
            const el = e.target.closest(clickSelector);
            if (!el) return;
            this.selectSeat(el);
        });

        // Reaplica a classe .selected após seleção em massa vinda do servidor.
        this.applySelectedClasses();

        attachPanzoom(() => this.$refs.mapbgzoom, {fit, minScale});

        this.inited = true;
    },

    selectSeat(el) {
        const seatId = el.id;
        const idx = this.tempSelectedSeats.findIndex((s) => s.id === seatId);
        if (idx === -1) {
            this.tempSelectedSeats.push({index: this.tempSelectedSeats.length, id: seatId});
            el.classList.add('selected');
        } else {
            this.tempSelectedSeats.splice(idx, 1);
            el.classList.remove('selected');
        }
    },

    applySelectedClasses() {
        const ids = this.selectedSeats.map((s) => String(s.id));
        this.$refs.mapbgzoom.querySelectorAll('.seat').forEach((el) => {
            if (ids.includes(el.id)) {
                el.classList.add('selected');
            } else {
                el.classList.remove('selected');
            }
        });
    },

    syncSeats(ids) {
        const strIds = (ids || []).map(String);
        this.tempSelectedSeats = strIds.map((id, i) => ({index: i, id}));
        this.$nextTick(() => this.applySelectedClasses());
    },

    resetSeats() {
        this.tempSelectedSeats = [];
        this.$refs.mapbgzoom.querySelectorAll('.seat.selected').forEach((el) => {
            el.classList.remove('selected');
        });
    },
});

document.addEventListener('alpine:init', () => {
    // Cortesia: aceita assento livre ou bloqueado; começa em escala 1 (medir a altura já
    // deixou o mapa "sumido" por timing de layout) e quem rola é o container pai.
    Alpine.data('courtesySeatPicker', (selectedSeats) => seatPickerBase(selectedSeats, {
        clickSelector: '.available-seat, .blocked-seat',
        fit: false,
        minScale: 0.5,
    }));

    // Venda de ingresso bloqueado: só assentos já bloqueados (blocked_seats).
    Alpine.data('blockedTicketSeatPicker', (selectedSeats) => seatPickerBase(selectedSeats, {
        clickSelector: '.blocked-seat',
        fit: true,
    }));

    // Emissão de cortesia com assento marcado.
    Alpine.data('generateMarkedTicketPicker', (selectedSeats, mapPoints) => ({
        selectedSeats,
        tempSelectedSeats: [],
        mapPoints,
        selected_ticket_category: null,
        inited: false,
        blockedSeat: false,

        removeSeat(el) {
            const seatId = el.id;
            this.tempSelectedSeats = this.tempSelectedSeats.filter((s) => s.id !== seatId);
            if (el) {
                el.classList.remove('selected-seat');
                el.classList.add('available-seat');
            }
            this.$wire.removeSeat(seatId);
        },

        resetSeats() {
            this.tempSelectedSeats = [];
            this.selectedSeats = [];
            this.selected_ticket_category = null;
            document.querySelectorAll('.seat.selected').forEach((sector) => {
                sector.classList.remove('selected');
            });
        },

        syncSeats(ids) {
            const strIds = (ids || []).map(String);
            this.tempSelectedSeats = strIds.map((id, i) => ({index: i, id}));
            this.$nextTick(() => this.applySelectedClasses());
        },

        applySelectedClasses() {
            const ids = this.tempSelectedSeats.map((s) => String(s.id));
            this.$refs.mapbgzoom.querySelectorAll('.seat').forEach((el) => {
                if (ids.includes(el.id)) {
                    el.classList.add('selected');
                } else {
                    el.classList.remove('selected');
                }
            });
        },

        init() {
            if (this.inited) return;

            this.tempSelectedSeats = [...this.selectedSeats];

            this.$watch('tempSelectedSeats', Alpine.debounce(() => {
                this.selectedSeats = this.tempSelectedSeats;
            }, 300));

            this.$refs.mapbgzoom.addEventListener('click', (e) => {
                const el = e.target.closest('.available-seat, .blocked-seat, .selectionable-sector');

                if (!el) return;

                if (el.classList.contains('selectionable-sector')) {
                    this.selectSectorById(el.dataset.mapid || el.id);
                } else {
                    this.selectSeat(el);
                }
            });

            window.addEventListener('resetSeats', () => this.resetSeats());

            attachPanzoom(() => this.$refs.mapbgzoom, {fit: true});

            this.inited = true;
        },

        selectSector(el) {
            this.selectSectorById(el.id);
        },

        selectSeat(el) {
            const seatId = el.id;
            if (!el.classList.contains('available-seat') && !el.classList.contains('blocked-seat')) {
                return;
            }

            if (this.tempSelectedSeats.filter((s) => s.id === seatId).length === 0) {
                this.tempSelectedSeats.push({index: this.tempSelectedSeats.length, id: seatId});
                el.classList.add('selected');
            } else {
                this.tempSelectedSeats = this.tempSelectedSeats.filter((s) => s.id !== seatId);
                el.classList.remove('selected');
            }
        },

        selectSectorById(sectorId) {
            this.selected_ticket_category = sectorId;
            document.querySelectorAll('.selectionable-sector').forEach((ele) => {
                if (ele.dataset.mapid === sectorId) {
                    ele.classList.add('selected');
                } else {
                    ele.classList.remove('selected');
                }
            });
        },
    }));

    // Resgate de ingresso por voucher: um único assento por vez.
    Alpine.data('claimSeatPicker', (selectedSeats, mapPoints) => ({
        selectedSeats,
        tempSelectedSeats: [],
        mapPoints,
        selected_ticket_category: null,
        inited: false,
        blockedSeat: false,

        removeSeat(el) {
            const seatId = el.id;
            this.tempSelectedSeats = this.tempSelectedSeats.filter((s) => s.id !== seatId);
            if (el) {
                el.classList.remove('selected-seat');
                el.classList.add('available-seat');
            }
            this.$wire.removeSeat(seatId);
        },

        resetSeats() {
            this.tempSelectedSeats = [];
            this.selected_ticket_category = null;
            document.querySelectorAll('.available-seat.selected').forEach((sector) => {
                sector.classList.remove('selected');
            });
        },

        refreshListeners() {
            document.querySelectorAll('.available-seat, .blocked-seat').forEach((sector) => {
                sector.addEventListener('click', (e) => this.selectSeat(e.target));
            });
        },

        init() {
            if (this.inited) return;

            this.$watch('tempSelectedSeats', Alpine.debounce(() => {
                this.selectedSeats = this.tempSelectedSeats;
            }, 500));

            document.querySelectorAll('.available-seat, .blocked-seat').forEach((sector) => {
                sector.addEventListener('click', (e) => this.selectSeat(e.target));
            });

            document.querySelectorAll('.selectionable-sector').forEach((ele) => {
                ele.addEventListener('click', (e) => this.selectSector(e.target));
            });

            window.addEventListener('resetSeats', () => {
                this.resetSeats();
                this.refreshListeners();
            });

            const elem = this.$refs.mapbgzoom;
            window.cpanzoom = Panzoom(elem, {
                maxScale: 5,
                minScale: 1,
                excludeClass: 'seat selectionable-sector',
            });
            elem.parentElement.addEventListener('wheel', window.cpanzoom.zoomWithWheel);

            this.inited = true;
        },

        selectSector(el) {
            this.selectSectorById(el.id);
        },

        selectSeat(el) {
            const seatId = el.id;

            if (!el.classList.contains('available-seat') && !el.classList.contains('blocked-seat')) {
                return;
            }

            if (this.tempSelectedSeats.filter((s) => s.id === seatId).length === 0) {
                // Resgate é de um assento só: o novo substitui o anterior.
                this.tempSelectedSeats = [];
                this.tempSelectedSeats.push({index: this.tempSelectedSeats.length, id: seatId});
                el.classList.add('selected');
            } else {
                this.tempSelectedSeats = this.tempSelectedSeats.filter((s) => s.id !== seatId);
                el.classList.remove('selected');
            }
        },

        selectSectorById(sectorId) {
            this.selected_ticket_category = sectorId;
            document.querySelectorAll('.selectionable-sector').forEach((ele) => {
                if (ele.dataset.mapid === sectorId) {
                    ele.classList.add('selected');
                } else {
                    ele.classList.remove('selected');
                }
            });
        },
    }));

    // Troca de assento (admin > pagamentos).
    Alpine.data('changeSeatPicker', (selectedSeatId, currentSeatId) => ({
        selectedSeatId,
        currentSeatId,
        inited: false,

        init() {
            if (this.inited || !this.$refs.mapbgzoom) return;

            this.$refs.mapbgzoom.addEventListener('click', (e) => {
                const el = e.target.closest('.available-seat, .current-seat');
                if (!el) return;
                this.handleSeatClick(el);
            });

            // Observa mudanças (tanto do JS quanto do servidor) para atualizar o visual.
            this.$watch('selectedSeatId', (value) => {
                this.updateMapHighlights(value);
            });

            attachPanzoom(() => this.$refs.mapbgzoom, {fit: true, excludeClass: 'seat', delay: 300});

            this.inited = true;
        },

        handleSeatClick(el) {
            const seatId = el.id;

            if (seatId === this.currentSeatId) {
                this.selectedSeatId = null;
                return;
            }

            this.selectedSeatId = this.selectedSeatId === seatId ? null : seatId;
        },

        updateMapHighlights(selectedId) {
            // Limpa todos os verdes anteriores.
            this.$refs.mapbgzoom.querySelectorAll('.selected').forEach((s) => {
                s.classList.remove('selected');
            });

            if (selectedId) {
                // [id="..."] evita problemas com ids que começam com número ou têm caracteres especiais.
                const el = this.$refs.mapbgzoom.querySelector(`[id="${selectedId}"]`);
                if (el) el.classList.add('selected');
            }
        },
    }));
});
